import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { MentionsProviderQuery } from './MentionsProviderQuery.graphql';
import type { MentionsProviderQuery as MentionsProviderQueryType } from './__types__/MentionsProviderQuery';

export const preloadMentionsProvider = async () =>
	query<MentionsProviderQueryType, {}>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: MentionsProviderQuery,
	});
